import React, { useEffect, useState } from "react";
import axios from "axios";
import "./accountDeletion.css";
import baseUrl from "../../utils/baseUrl";

const GetAllAccountDeletionRequests = () => {

    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(false);

    // ======================================
    // Pagination States
    // ======================================

    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;

    // ======================================
    // Fetch Requests
    // ======================================

    const fetchRequests = async () => {

        try {

            setLoading(true);

            const response = await axios.get(
                `${baseUrl}/account-deletion`
            );

            setRequests(response.data.data || []);

        } catch (error) {

            console.error("Failed to fetch requests", error);

        } finally {

            setLoading(false);

        }
    };

    useEffect(() => {

        fetchRequests();

    }, []);

    // ======================================
    // Approve Request
    // ======================================

    const handleApprove = async (id) => {

        try {

            await axios.patch(
                `${baseUrl}/account-deletion/${id}/approve`
            );

            fetchRequests();

        } catch (error) {

            console.error("Failed to approve request", error);

        }
    };

    // ======================================
    // Disapprove Request
    // ======================================

    const handleDisapprove = async (id) => {

        try {

            await axios.patch(
                `${baseUrl}/account-deletion/${id}/disapprove`
            );

            fetchRequests();

        } catch (error) {

            console.error("Failed to disapprove request", error);

        }
    };

    // ======================================
    // Pagination Logic
    // ======================================

    const indexOfLastItem = currentPage * itemsPerPage;

    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const currentItems = requests.slice(
        indexOfFirstItem,
        indexOfLastItem
    );

    const totalPages = Math.ceil(
        requests.length / itemsPerPage
    );

    return (

        <div className="account-deletion-wrapper">

            <div className="account-deletion-table-card">

                <div className="table-header">
                    <h2>Account Deletion Requests</h2>
                </div>

                {loading ? (

                    <div className="loading-text">
                        Loading requests...
                    </div>

                ) : (

                    <>
                        <div className="table-responsive">

                            <table className="deletion-table">

                                <thead>

                                    <tr>
                                        <th>#</th>
                                        <th>Email</th>
                                        <th>Reason</th>
                                        <th>Status</th>
                                        <th>Date</th>
                                        <th>Actions</th>
                                    </tr>

                                </thead>

                                <tbody>

                                    {currentItems.length > 0 ? (

                                        currentItems.map((item, index) => (

                                            <tr key={item.id}>

                                                <td>
                                                    {indexOfFirstItem + index + 1}
                                                </td>

                                                <td>
                                                    {item.email}
                                                </td>

                                                <td className="reason-column">
                                                    {item.reason}
                                                </td>

                                                <td>
                                                    <span
                                                        className={`status-badge ${item.status}`}
                                                    >
                                                        {item.status}
                                                    </span>
                                                </td>

                                                <td>
                                                    {new Date(
                                                        item.createdAt
                                                    ).toLocaleDateString()}
                                                </td>

                                                <td>

                                                    {item.status === "pending" ? (

                                                        <div className="action-buttons">

                                                            <button
                                                                className="approve-btn"
                                                                onClick={() =>
                                                                    handleApprove(item.id)
                                                                }
                                                            >
                                                                Approve
                                                            </button>

                                                            <button
                                                                className="disapprove-btn"
                                                                onClick={() =>
                                                                    handleDisapprove(item.id)
                                                                }
                                                            >
                                                                Disapprove
                                                            </button>

                                                        </div>

                                                    ) : (

                                                        <span className="completed-text">
                                                            Completed
                                                        </span>

                                                    )}

                                                </td>

                                            </tr>

                                        ))

                                    ) : (

                                        <tr>

                                            <td colSpan="6">

                                                <div className="no-data">
                                                    No deletion requests found
                                                </div>

                                            </td>

                                        </tr>

                                    )}

                                </tbody>

                            </table>

                        </div>

                        {/* ====================================== */}
                        {/* Pagination */}
                        {/* ====================================== */}

                        {requests.length > itemsPerPage && (

                            <div className="pagination-wrapper">

                                <button
                                    disabled={currentPage === 1}
                                    onClick={() =>
                                        setCurrentPage(currentPage - 1)
                                    }
                                    className="pagination-btn"
                                >
                                    Previous
                                </button>

                                <span className="pagination-text">
                                    Page {currentPage} of {totalPages}
                                </span>

                                <button
                                    disabled={currentPage === totalPages}
                                    onClick={() =>
                                        setCurrentPage(currentPage + 1)
                                    }
                                    className="pagination-btn"
                                >
                                    Next
                                </button>

                            </div>

                        )}

                    </>

                )}

            </div>

        </div>
    );
};

export default GetAllAccountDeletionRequests;